goog.provide("shadow.js.shim.module$$carbon$icons_react$es$send__alt$24");
goog.provide("module$shadow_js_shim_module$$carbon$icons_react$es$send__alt$24");
shadow.js.shim.module$$carbon$icons_react$es$send__alt$24 = shadow.js.nativeProvides["@carbon/icons-react/es/send--alt/24"] = shadow$bridge("@carbon/icons-react/es/send--alt/24");
module$shadow_js_shim_module$$carbon$icons_react$es$send__alt$24.default = shadow.js.shim.module$$carbon$icons_react$es$send__alt$24;
